import React, { Component } from "react";
import { connect } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

export class SimpleSnackbar extends Component {
  state = { open: false };

  componentDidUpdate({ snackbarMassage, snackbarTimestamp }) {
    if (
      this.props.snackbarMassage !== snackbarMassage ||
      this.props.snackbarTimestamp !== snackbarTimestamp
    ) {
      this.setState({ open: true });
    }
  }

  handleClose = () => this.setState({ open: false });

  render() {
    const { open } = this.state;
    const { snackbarMassage } = this.props;
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
        open={open}
        autoHideDuration={6000}
        onClose={this.handleClose}
        ContentProps={{
          "aria-describedby": "message-id"
        }}
        message={<span id="message-id">{snackbarMassage}</span>}
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            // className={classes.close}
            onClick={this.handleClose}
          >
            <CloseIcon />
          </IconButton>
        ]}
      />
    );
  }
}

const mapStateToProps = state => ({
  snackbarMassage: state.ui.snackbarMassage,
  snackbarTimestamp: state.ui.snackbarTimestamp
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SimpleSnackbar);
